import script from "./global-search-section.vue?vue&type=script&setup=true&lang=js"
export * from "./global-search-section.vue?vue&type=script&setup=true&lang=js"

import "./global-search-section.vue?vue&type=style&index=0&id=90665e3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90665e3a"]])

export default __exports__